

/**
 * @name AvailabilityCheckController
 * @description Controller to check availability
 * @param {type} $uibModalInstance Description
 */
function AvailabilityCheckController(
  $uibModalInstance
) {
  let vm = this;

  vm.close = function() {
    $uibModalInstance.dismiss('close');
  };
}

angular
  .module('inkfinder')
  .controller('AvailabilityCheckController', AvailabilityCheckController);



// WEBPACK FOOTER //
// ./components/schedule/check-availability/availability.controller.js